// @ts-ignore
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { GemsApiStoneShapeWithInfoFragmentDoc } from './GemsApiStoneShapeInfo.fragment.generated';
import { GemsRangeFragmentDoc } from './range.fragment.generated';
import { GemsIntRangeFragmentDoc } from './intRange.fragment.generated';
import { GemsPriceRangeInLocalCurrencyFragmentDoc } from './priceRanceLocalCurrency.fragment.generated';
export const GemsBoundsFragmentDoc = gql`
    fragment gemsBounds on GemsApi_Bounds {
  colour
  grade
  shape
  shapes {
    ...GemsApiStoneShapeWithInfo
  }
  clarity
  fluorescence
  cut
  polish
  symmetry
  shippingFromCountry
  originCountry
  category
  crystal
  weight {
    ...gemsRange
  }
  depthPercent {
    ...gemsRange
  }
  tablePercent {
    ...gemsRange
  }
  ratio {
    ...gemsRange
  }
  length {
    ...gemsRange
  }
  width {
    ...gemsRange
  }
  depth {
    ...gemsRange
  }
  deliveryDays {
    ...gemsIntRange
  }
  price {
    ...gemsPriceRangeInLocalCurrency
  }
  priceByShape {
    shape
    range {
      ...gemsPriceRangeInLocalCurrency
    }
  }
}
    ${GemsApiStoneShapeWithInfoFragmentDoc}
${GemsRangeFragmentDoc}
${GemsIntRangeFragmentDoc}
${GemsPriceRangeInLocalCurrencyFragmentDoc}`;